import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.REGISTRATIONS]: {
		el: {
			'Invalid date': 'Μη έγκυρη ημερομηνία',
			'Work registration already exists for the selected Foreman for selected day.': 'Υπάρχει ήδη καταχώρηση για τον επιλεγμένο Εργοδηγό στην ημερομηνία που επιλέξατε.',
			'extraWorkMessage': 'Ο Εργαζόμενος έχει ήδη καταχωρημένες {{extraWorkTm}} ώρες και το σύνολο ωρών και υπερωριών πρέπει να είναι ίσο ή μικρότερο από 24.',
			'workTimeMessage': 'Ο Εργαζόμενος έχει ήδη καταχωρημένες {{workTm}} ώρες για το έργο {{work}} και το σύνολο ωρών εργασίας πρέπει να είναι ίσο ή μικρότερο από 7.',
			'Actions':'Ενέργειες',
			'Add' : 'Προσθήκη',
			'Edit' : 'Επεξεργασία',
			'Registrations List' : 'Λίστα καταχωρήσεων',
			'Registrations' : 'Καταχωρήσεις',
			'Registration Create' : 'Δημιουργία καταχώρησης',
			'Project' : 'Έργο',
			'Foreman' : 'Εργοδηγός',
			'WorkDt' : 'Ημέρα εργασίας',
			'Worker' : 'Εργαζόμενος',
			'Work Time' : 'Ωρες εργασίας',
			'Extra Work Time' : 'Υπερωρίες',
			'Return' : 'Επιστροφή',
			'Save' : 'Αποθήκευση',
			'Registration Edit' : 'Επεξεργασία καταχώρησης',
			'Required' : 'Υποχρεωτικό πεδίο',
			'Edit Registration' : 'Επεξεργασία καταχώρησης',
			'Registration created successfully!' : 'H καταxώρηση δημιουργήθηκε με επιτυχία',
			'Registration updated successfully!' : 'H καταxώρηση ανανεώθηκε με επιτυχία',
			'Delete' : 'Διαγραφή',
			'Description' : 'Περιγραφή',
			'All data related to this registration will be deleted!' : 'Όλα τα δεδομένα που σχετίζονται με αυτή τη καταχώρηση θα διαγραφούν!',
			'Registration deleted successfully!' : 'Η καταχώρηση διαγράφηκε με επιτυχία!',
			'Unable to delete registration!' : 'Η καταχώρηση δεν μπορεί να διαγραφεί!',
			'Total Work Time' : 'Σύνολο ωρών',
			'Total Extra Work Time' : 'Σύνολο υπερωριών',
			'Υou must enter a number less than 7.' : 'Πρέπει να εισάγετε αριθμό μικρότερο του 7.',
			'Υou must enter a number less than 25.' : 'Πρέπει να εισάγετε αριθμό μικρότερο του 25.',
			'You must enter a positive number.' :  'Πρέπει να εισάγετε θετικό αριθμό.',
			'Only numbers in 0.5 increments are allowed (e.g. 1, 1.5, 2)' : 'Επιτρέπονται μόνο αριθμοί σε προσαυξήσεις 0,5 (π.χ. 1, 1,5, 2)',
			'Total Work Time for this worker must be smaller or equal with 7.' : 'Το σύνολο ωρών εργασίας για τον εργοδότη πρέπει να είναι ίσο ή μικρότερο από 7.',
			'Total Time from work time and extra work time of worker must be smaller or equal with 24.' : 'Το σύνολο ωρών και υπερωριών του εργοδότη πρέπει να είναι ίσο ή μικρότερο από 24.',
			// 'Date must be between {{start}} and {{end}}' : 'Η ημερομηνία πρέπει να είναι μεταξύ {{start}} και {{end}}',
			'registration_error': 'Ο εργάτης {{worker}}, για την ημερομηνία {{workDt}} έχει ήδη καταχωρημένες {{workHours}} ώρες και σύνολο {{totalHours}} ώρες.',
			"dateOutOfRange": "Η ημερομηνία πρέπει να είναι μεταξύ {{start}} και {{end}}",
			"Work remove successfully!" : "Η εργασία διαγράφηκε με επιτυχία!",
			"Registration copied successfully!" : "Επιτυχής αντιγραφή καταχώρησης",
			"Clear":"Καθαρισμός",
			"Update":"Ενημέρωση",
			"Delete registration row?":"Διαγραφή γραμμής καταχώρησης?",
			"Cancel":"Ακύρωση",
			"Confirm":"Επιβεβαίωση",
			"Date":"Ημ/νία",
			"Extra Hours":"Extra Ώρες",
			"Ext Hour":"Υπερ/ρίες",
			"Work Times":"Ωρ.Εργ.",
			"Copy":"Αντιγραφή",
			"Sort":"Ταξινόμηση",
			"Search":"Αναζήτηση",
			"Data not found!":"Δεν βρέθηκαν καταχωρήσεις!"

		},
		en: {
			'extraWorkMessage': 'Worker already has {{extraWorkTm}} hours and total time from work and extra work must be smaller or equal with 24.',
			'WorkDt' : 'Work Date',
			"dateOutOfRange": "Date must be between {{start}} and {{end}}",
			"workTimeMessage": 'Worker already has {{workTm}} hours for this project {{work}} and total work time must be smaller or equal with 7.',
			'registration_error': 'Worker {{worker}} has already registered for {{workDt}} {{workHours}} hours and {{totalHours}} hours total.'
		}
	},
}

export default locales